<template>
  <div class="footer-spacer"
  v-if="$route.path !== '/likes'"
  :style="{ height: footerHeight + 'px' }"
  />
  <div class='EnbFooter'
  v-if="$route.path !== '/likes'"
  :ref="setFooter"
  :style="{
    backgroundColor: Prefes.rodape.corBackground,
    fontFamily: Prefes.rodape.font,
    color: Prefes.rodape.corFont,
    fontStyle: parseInt(Prefes.rodape.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.rodape.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.rodape.textDecoration) ? 'underline' : '',
    fontSize: Prefes.rodape.fontHeight + 'px'
  }"
  >
    <div class="nets">
      <div class="net">
        <facebook-icon
        @click="push(Empresa.facebook)"
        :color="Prefes.rodape.corFont"
        />
      </div>
      <div class="net">
        <instagram-icon
        @click="push(Empresa.instagram)"
        :color="Prefes.rodape.corFont"
        />
      </div>
      <div class="net">
        <whats-icon :tam="'30px'"
        :color="Prefes.rodape.corFont"
        @click="push(`https://wa.me/55${Empresa.whatsapp}`)"
        />
      </div>
    </div>
    <div class="enbC" style="font-size: 10px;">
      e-Negócios © 2026
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FacebookIcon from '../Icons/FacebookIcon'
import InstagramIcon from '../Icons/InstagramIcon'
import WhatsIcon from '../Icons/WhatsIcon'
export default {
  name: 'EnbFooter',
  components: { FacebookIcon, InstagramIcon, WhatsIcon },
  data () {
    return {
      footerHeight: 0
    }
  },
  computed: {
    ...mapGetters(['Prefes', 'Empresa'])
  },
  created () {
    // o footer é fixo, então o spacer reserva a altura dele no fim da página
    this.observer = new ResizeObserver(([entry]) => {
      this.footerHeight = entry.target.offsetHeight
    })
  },
  beforeUnmount () {
    this.observer.disconnect()
  },
  methods: {
    setFooter (el) {
      if (el === this.footerEl) return
      if (this.footerEl) this.observer.unobserve(this.footerEl)
      this.footerEl = el
      if (el) this.observer.observe(el)
      else this.footerHeight = 0
    },
    push (src) {
      window.location.replace(src)
    }
  }
}
</script>

<style scoped>
.EnbFooter {
  width: 100%;
  box-sizing: border-box;
  padding: 1%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
  color: #FFFFFF;
}

.nets {
  display: flex;
  justify-content: center;
}

.net {
  padding-left: 3px;
  padding-right: 3px;
}

.enbC {
  padding-top: 3%;
}

/* no mobile o rodapé não é exibido; o spacer reserva só a altura do SideBottom (fixo, 10% de altura) */
@media (max-width: 500px) {
  .EnbFooter {
    display: none;
  }

  .footer-spacer {
    height: 10vh !important;
  }
}
</style>
